import React, { useEffect } from "react";
import { useState } from "react";
import { supabase } from "../../../supabaseClient";
import { Send } from "react-bootstrap-icons";

// Language Data
import koData from "../../../data/i18n/ko.json";
import jaData from "../../../data/i18n/ja.json";
import enData from "../../../data/i18n/en.json";

// Components
import CustomAlert from "../../Common/CustomAlert/CustomAlert";

// SCSS
import "./GuestBookWindow.scss";

const GuestBookWindow = ({ lang, setHoveredElement }) => {
  // Language
  const langFiles = { ko: koData, ja: jaData, en: enData };
  const currentData = langFiles[lang] || koData;

  // Alert
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const showAlert = (text) => {
    setAlertMsg(text);
    setIsAlertOpen(true);
  };

  // Message
  const [inputText, setInputText] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const MAX_LENGTH = 140;

  const fetchMessages = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("guestbook")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      setMessages(data);
    } catch (error) {
      showAlert("Failed to load messages.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputText.trim()) {
      showAlert("Please enter a message!");
      return;
    }

    if (loading) return;

    try {
      setLoading(true);

      const { error } = await supabase.from("guestbook").insert([
        {
          message: inputText,
          profile_index: Math.floor(Math.random() * 10) + 1,
        },
      ]);

      if (error) throw error;

      showAlert("Message sent successfully!");
      setInputText("");
      fetchMessages();
    } catch (error) {
      showAlert("Failed to send message.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="GuestBookWindow">
      <section className="State">
        <div className="State__Wrapper">
          <div className="State__Image">
            <img src={currentData.profile} alt="profile" />
          </div>
          <div className="State__Name">
            <h3 className="State__Name-Text">To chaeyeon…</h3>
          </div>
        </div>
      </section>
      <section className="MyBubble">
        <div className="MyBubble__Wrapper">
          <div className="MyBubble__Container">
            <div className="MyBubble__Chat">
              <p className="MyBubble__Chat-Text">{currentData.bubble}</p>
            </div>
          </div>
        </div>
      </section>
      <section className="OtherBubble">
        <div className="OtherBubble__Wrapper">
          {loading ? (
            <div className="Loading__Dot">
              <div className="Loading__Dot-Circle"></div>
              <div className="Loading__Dot-Circle"></div>
              <div className="Loading__Dot-Circle"></div>
            </div>
          ) : (
            messages.map((item) => (
              <div key={item.id} className="OtherBubble__Container">
                <div className="OtherBubble__Chat">
                  <span className="OtherBubble__Chat-Information">
                    Anonymous · {new Date(item.created_at).toLocaleDateString()}
                  </span>
                  <p className="OtherBubble__Chat-Text">{item.message}</p>
                </div>
                <div className="OtherBubble__Profile">
                  <img
                    src={`/assets/guest/profile${String(((item.profile_index - 1) % 10) + 1).padStart(2, "0")}.jpg`}
                    alt="profile"
                    className="OtherBubble__Profile-Image"
                  />
                </div>
              </div>
            ))
          )}
        </div>
      </section>
      <section className="InputArea">
        <div className="InputArea__Wrapper">
          <form className="InputArea__Form" onSubmit={handleSubmit}>
            <label htmlFor="sendMessage" className="InputArea__Label"></label>
            <input
              id="sendMessage"
              type="text"
              autoComplete="off"
              maxLength={MAX_LENGTH}
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              placeholder="Send a message…"
              className="InputArea__Input"
            />
            <span className="InputArea__CharCounter">
              {inputText.length} / {MAX_LENGTH}
            </span>
            <button type="submit" className="InputArea__Button">
              {loading ? <div className="Loading__Spinner"></div> : <Send />}
            </button>
          </form>
        </div>
      </section>

      {isAlertOpen && (
        <CustomAlert
          message={alertMsg}
          onClose={() => setIsAlertOpen(false)}
          setHoveredElement={setHoveredElement}
        />
      )}
    </div>
  );
};

export default GuestBookWindow;
